<template>
  <div class="flag-wrapper text-small disable-user-select">
    <div id="flag-picker" @click="showDropdown = !showDropdown">
      <div class="flag">
        <img
          :src="`https://www.countryflags.io/${currentLanguage.id}/flat/32.png`"
          :alt="`${currentLanguage.name}`"
        />
        {{ currentLanguage.name }}
      </div>
      <div class="dropdown" v-if="showDropdown">
        <div
          class="flag"
          v-for="x in availableLanguages.filter(l => l.id !== currentLanguage.id)"
          @click="currentLanguage = x"
          :key="x.id"
        >
          <img
            :alt="`${x.name}`"
            :src="`https://www.countryflags.io/${x.id}/flat/32.png`"
          />
          {{ x.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      showDropdown: false,
    }
  },
  computed: {
    availableLanguages () {
      return this.$store.getters.availableLanguages
    },
    currentLanguage: {
      get () {
        return this.$store.getters.currentLanguage
      },
      set (x) {
        this.$store.commit('setCurrentLanguage', x)
      },
    },
  },
}
</script>
<style lang="less">
@import '../style/variables.less';
.flag-wrapper {
  display: flex;
  align-items: flex-start;
}
#flag-picker {
  flex-direction: column;
  cursor: pointer;
  .flag {
    display: flex;
    align-items: center;
    padding: 2px 6px;
    img {
      width: 24px;
      height: 24px;
      margin-right: 6px;
    }
  }
  > .flag {
    color: white;
    background: rgba(@color-grey, .3);
  }
  .flag:hover {
  }
  .dropdown {
    .flag {
      background: rgba(@color-grey, .3);
    }
    .flag:hover {
      background: @color-grey;
    color: white;
    }
    display: flex;
    flex-direction: column;
    margin-top: 2px;
  }
}
</style>
